import Menu from './menu'
import './menu.less'

export default Menu
